/** Meta Pixel LyrraOne — aligné sur index.html et BaseLayout marketing. */
export const META_PIXEL_ID = '1020135500500116';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/** Chemins app connectée : pas de PageView Meta sur navigation interne. */
const PRIVATE_PATH_PREFIXES = [
  '/dashboard',
  '/marketing',
  '/settings',
  '/admin',
  '/institution',
  '/projects',
  '/analytics',
  '/media',
  '/funnel',
  '/sales-funnel',
  '/training',
  '/certifications',
  '/commerce',
  '/help',
];

export function isMetaPixelPublicPath(pathname: string): boolean {
  return !PRIVATE_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function trackMetaPageView(): void {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
}
